module.exports = __webpack_public_path__ + "e2cc0a722bdea6c5a52932729b2bb96a.jpg";